import React, {useContext} from 'react';
import {Space, theme} from 'antd';
import {observer} from "mobx-react";
import {ViewCardStyled} from "../../components/styled/card.styled";
import {Translate} from "../../components/util/translation.util";
import {TranslationDomainEnum} from "../../types/enums";
import {Helmet} from 'react-helmet-async';
import {StoreContext} from '../../store.context';

export const Home: React.FC = observer(() => {
    const {token} = theme.useToken();
    const {appStore: {translate}} = useContext(StoreContext);
    const translationDomain = TranslationDomainEnum.MESSAGES;
    const title = translate('userMenuItemEnum.homepage', {}, translationDomain);

    return (
            <>
                <Helmet>
                    <title>{`CL BO - ${title}`}</title>
                </Helmet>
                <Space direction="vertical" size="small" style={{display: 'flex'}}>
                    <ViewCardStyled title={
                        <Translate message={`homePage.title`} domain={TranslationDomainEnum.MESSAGES} raw={true}/>
                    } style={{
                        background: token.colorBgContainer,
                    }}>
                        <Space direction="vertical" size="small" style={{display: 'flex', padding: "24px"}}>
                            <Translate message={`homePage.text`} domain={TranslationDomainEnum.MESSAGES} raw={true}/>
                        </Space>
                    </ViewCardStyled>
                </Space>
            </>

    )
})